// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__21L6O","search":"Settings_search__KEJtG","filter":"Settings_filter__2LLdG"};